import React from "react";
import { Card, Alert } from "react-bootstrap";

function Invitations() {
  return (
    <div>
      <h2 className="mb-4">
        Inviting Users
      </h2>

      <Alert variant="warning">
        <strong>Admin Feature:</strong> This feature is only available to users with Admin permissions.
      </Alert>

      <Card className="mb-4">
        <Card.Body>
          <h4>About Invitations</h4>
          <p>
            The invitation system allows admins to invite new users to join the portal. Instead of manually
            creating user accounts, you send an invitation email, and the recipient can register themselves.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Sending an Invitation</h4>
          <ol>
            <li>Click <strong>Invitations</strong> in the Settings section of the left menu</li>
            <li>Click the <strong>Send Invitation</strong> button</li>
            <li>Enter the recipient's email address</li>
            <li>Select the role and permissions for the new user</li>
            <li>Click <strong>Send</strong></li>
            <li>An invitation email will be sent to the recipient</li>
          </ol>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Invitation Status</h4>
          <p>Invitations can have different statuses:</p>
          <ul>
            <li><strong>Pending</strong> - Invitation sent but not yet accepted</li>
            <li><strong>Accepted</strong> - User has registered and created their account</li>
            <li><strong>Expired</strong> - Invitation expired before being accepted</li>
          </ul>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Viewing Invitations</h4>
          <p>
            The Invitations grid shows all sent invitations, including:
          </p>
          <ul>
            <li>Recipient email address</li>
            <li>Invitation status</li>
            <li>Date sent</li>
            <li>Expiration date</li>
            <li>Who sent the invitation</li>
          </ul>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Resending Invitations</h4>
          <p>
            If a user didn't receive the invitation email or it expired, you can resend it:
          </p>
          <ol>
            <li>Find the invitation in the grid</li>
            <li>Select it and click <strong>Resend</strong></li>
            <li>A new invitation email will be sent</li>
          </ol>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Canceling Invitations</h4>
          <p>
            To revoke an invitation before it's accepted:
          </p>
          <ol>
            <li>Find the invitation in the grid</li>
            <li>Select it and click <strong>Cancel</strong></li>
            <li>The invitation link will no longer work</li>
          </ol>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>What Recipients Receive</h4>
          <p>
            When you send an invitation, the recipient receives an email containing:
          </p>
          <ul>
            <li>A welcome message</li>
            <li>A secure registration link</li>
            <li>Instructions for creating their account</li>
            <li>Expiration information</li>
          </ul>
          <p className="mt-3">
            When they click the link, they'll be taken to a registration page where they can set their password
            and complete their account setup.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Best Practices</h4>
          <ul>
            <li>Double-check email addresses before sending invitations</li>
            <li>Assign appropriate roles and permissions based on the user's job responsibilities</li>
            <li>Follow up with recipients if they don't accept within a few days</li>
            <li>Keep track of pending invitations and resend if needed</li>
            <li>Cancel unused invitations to maintain security</li>
          </ul>
        </Card.Body>
      </Card>
    </div>
  );
}

export default Invitations;
